
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M21 13H3V11H21V13Z" fill="currentColor"></path></svg>';export default svg;
    